import React from "react";

type PropsType = {
  color?: string;
  style?: React.CSSProperties;
  size?: number;
};

const ChevronUp = ({
  size = 20,
  style = {},
  color = "currentColor",
}: PropsType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={(size / 20) * 21}
      style={style}
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0002 8.76193L14.4109 13.1727C14.7363 13.4981 15.264 13.4981 15.5894 13.1727C15.9149 12.8472 15.9149 12.3196 15.5894 11.9942L10.5894 6.99416C10.264 6.66872 9.73634 6.66872 9.41091 6.99416L4.41091 11.9942C4.08547 12.3196 4.08547 12.8472 4.41091 13.1727C4.73634 13.4981 5.26398 13.4981 5.58942 13.1727L10.0002 8.76193Z"
        fill={color}
      />
      <mask
        id="mask0_23_664"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="6"
        width="12"
        height="8"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.0002 8.76193L14.4109 13.1727C14.7363 13.4981 15.264 13.4981 15.5894 13.1727C15.9149 12.8472 15.9149 12.3196 15.5894 11.9942L10.5894 6.99416C10.264 6.66872 9.73634 6.66872 9.41091 6.99416L4.41091 11.9942C4.08547 12.3196 4.08547 12.8472 4.41091 13.1727C4.73634 13.4981 5.26398 13.4981 5.58942 13.1727L10.0002 8.76193Z"
          fill={color}
        />
      </mask>
      <g mask="url(#mask0_23_664)"></g>
    </svg>
  );
};

export default ChevronUp;
